export default [
  {
    path: "/CartNotFound",
    name: "CartNotFound",
    hidden: true,
    component: () => import("@/views/error/CartNotFound.vue"),
    meta: {
      title: "Cart not found",
      error: true,
      noCache: true,
    },
  },
  {
    path: "/403",
    name: "Forbidden",
    hidden: true,
    component: () => import("@/views/error/403.vue"),
    meta: {
      title: "Forbidden",
      error: true,
      noCache: true,
    },
  },
  {
    path: "/404",
    name: "NotFound",
    hidden: true,
    component: () => import("@/views/error/404.vue"),
    meta: {
      title: "Not Found",
      error: true,
      noCache: true,
    },
  },
  {
    path: "/redirect/:url",
    name: "Redirect",
    hidden: true,
    component: () => import("@/views/error/Redirect.vue"),
    props: (route) => ({ url: route.params.url }),
    meta: {
      title: "Redirect",
      error: false,
      noCache: true,
    },
  },
  {
    path: "*",
    hidden: true,
    name: "NoFound",
    component: () => import("@/views/error/404.vue"),
    meta: {
      title: "Not Found",
    },
  },
];
